import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import { useHistory, useLocation } from "react-router-dom";
import logo from "assets/img/positron_logo.png";
import { MainContext } from "context/MainContext";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBell,
  faSignOut,
  faUniversity,
  faLaptop,
  faSuitcase,
  faMicrochip,
  faBookmark,
  faGears,
  faCity,
  faChartLine,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { useTranslation } from "react-i18next";

library.add(faBell);
library.add(faSignOut);
library.add(faUniversity);
library.add(faLaptop);
library.add(faSuitcase);
library.add(faMicrochip);
library.add(faBookmark);
library.add(faGears);
library.add(faCity);
library.add(faChartLine);
library.add(faUsersGear);

var ps;

function Sidebar(props) {
  const [collapseStates, setCollapseStates] = React.useState({});
  const sidebar = React.useRef();
  const privileges = useContext(MainContext);
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  // this creates the intial state of this component based on the collapse routes
  // that it gets through props.routes
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };
  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect || !prop.visible) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !collapseStates[prop.state];
        if (
          privileges[prop.privilegeKey] <=
            sessionStorage.getItem("privilegeLevel") &&
          ((prop.license == true &&
            Utilities.validateLicense(
              sessionStorage.getItem("licenseTypes"),
              prop.licenseType,
            )) ||
            !prop.license)
        ) {
          return (
            <li
              className={getCollapseInitialState(prop.views) ? "active" : ""}
              key={key}
            >
              <a
                href=""
                data-toggle="collapse"
                aria-expanded={collapseStates[prop.state]}
                onClick={(e) => {
                  e.preventDefault();
                  setCollapseStates(st);
                }}
              >
                {prop.icon !== undefined ? (
                  <>
                    <span style={{ width: "1rem", display: "inline-block" }}>
                      <FontAwesomeIcon icon={prop.icon} size="2x" />
                    </span>
                    {props.sidebarMini ? (
                      ""
                    ) : (
                      <span
                        style={{
                          marginLeft: "1.5rem",
                          verticalAlign: "center",
                        }}
                      >
                        {t(
                          prop.name + sessionStorage.getItem("bundleType"),
                          prop.name,
                        )}
                        <b className="caret custom-carret" />
                      </span>
                    )}
                  </>
                ) : (
                  // POS-3206 (Mini)
                  <>
                    <span className="sidebar-mini-icon">•</span>
                    <span className="sidebar-normal">
                      {prop.name}
                      <b className="caret custom-carret" />
                    </span>
                  </>
                )}
              </a>
              <Collapse isOpen={collapseStates[prop.state]}>
                <ul className="nav">{createLinks(prop.views)}</ul>
              </Collapse>
            </li>
          );
        }
      }

      if (
        privileges[prop.privilegeKey] <=
          sessionStorage.getItem("privilegeLevel") &&
        ((prop.license == true &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            prop.licenseType,
          )) ||
          !prop.license)
      ) {
        return (
          <li className={activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink
              to={prop.layout + prop.path}
              activeClassName=""
              onClick={(e) => {
                if (location.pathname === prop.layout + prop.path) {
                  e.preventDefault();
                  history.replace({
                    pathname: prop.layout + prop.path,
                    state: { forceRefresh: Date.now() },
                  });
                }
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <span style={{ width: "1rem", display: "inline-block" }}>
                    <FontAwesomeIcon icon={prop.icon} size="2x" />
                  </span>

                  {props.sidebarMini ? (
                    ""
                  ) : (
                    <span
                      style={{
                        marginLeft: "1.5rem",
                      }}
                    >
                      {t(
                        prop.name + sessionStorage.getItem("bundleType"),
                        prop.name,
                      )}
                    </span>
                  )}
                </>
              ) : (
                // POS-3206 (Mini)
                <>
                  <span className="sidebar-mini-icon">•</span>
                  <span className="sidebar-normal" style={{ fontSize: "13px" }}>
                    {t(
                      prop.name + sessionStorage.getItem("bundleType"),
                      prop.name,
                    )}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        );
      }
    });
  };
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      // we need to destroy the false scrollbar when we navigate
      // to a page that doesn't have this component rendered
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  React.useEffect(() => {
    setCollapseStates(getCollapseStates(props.routes));
  }, []);

  return (
    <div
      className="sidebar"
      id="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="sidebar-wrapper" ref={sidebar}>
        <div className="user">
          <div className="photo">
            <img onClick={props.handleMiniClick} src={logo} />
          </div>
          <div
            className="info"
            onClick={props.handleMiniClick}
            style={{
              fontSize: "16px",
              color: "white",
              cursor: "pointer",
              paddingTop: "5px",
            }}
          >
            VIRTUOSO
          </div>
        </div>
        <div className="loggedUser">
          Logged as{" "}
          <b>
            {sessionStorage.getItem("user")}(
            {sessionStorage.getItem("privilegeLevel")})
          </b>
        </div>
        <Nav>{createLinks(props.routes)}</Nav>
      </div>
    </div>
  );
}

export default Sidebar;
